import PastContributions from './PastContributions';

export default PastContributions;
